// System Pulse card (right rail). REAL: Enterprise Pulse V1 facets
// (deriveEnterprisePulseV1 — activity/direction/momentum, real-or-absent). PLACEHOLDER
// (mockData): the waveform + Models/Operators status rows.
import React from "react";
import { useBrainResource } from "../lib/hooks";
import { deriveEnterprisePulseV1 } from "../lib/pulse";
import { MOCK_PULSE } from "../mock/mockData";

function d(r) { return r && r.status === "ok" ? r.data : null; }
const DOT = { online: "bg-emerald-400", active: "bg-emerald-400", idle: "bg-amber-400", offline: "bg-slate-600" };
const VAL_TONE = { positive: "text-emerald-300", accelerating: "text-emerald-300", negative: "text-rose-300", slowing: "text-amber-300" };

export default function SystemPulseCard() {
  const buHealth = useBrainResource("/bu/health");
  const schedulers = useBrainResource("/schedulers/health");
  const integrations = useBrainResource("/integrations/health");
  const observations = useBrainResource("/intelligence/observations");
  const outcomes = useBrainResource("/outcomes/summary");
  const velocityTrends = useBrainResource("/velocity/trends", { params: { periods: 6 } });

  const pulse = deriveEnterprisePulseV1({
    buHealth: d(buHealth), schedulers: d(schedulers), integrations: d(integrations),
    observations: d(observations) ? d(observations).observations || d(observations) : null,
    outcomesSummary: d(outcomes), velocityTrends: d(velocityTrends),
  });

  const wf = MOCK_PULSE.waveform;
  const pts = wf.map((v, i) => `${(i / (wf.length - 1)) * 100},${20 - (v / Math.max(...wf)) * 18}`).join(" ");

  return (
    <div data-testid="system-pulse-card" className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-200">System Pulse</h3>
        <span className="rounded bg-slate-800 px-1.5 py-0.5 text-[10px] text-slate-400">V1</span>
      </div>

      <svg viewBox="0 0 100 20" width="100%" height="28" preserveAspectRatio="none" aria-hidden="true" title="MOCK — waveform placeholder">
        <polyline points={pts} fill="none" stroke="#34d399" strokeOpacity="0.7" strokeWidth="1" />
      </svg>
      <p className="-mt-1 text-[9px] text-slate-600">waveform * placeholder</p>

      <div className="mt-2 space-y-1">
        {pulse.facets.map((f) => (
          <div key={f.key} className="flex items-center justify-between text-xs" data-testid={`pulse-facet-${f.key}`}>
            <span className="text-slate-400">{f.label}</span>
            {f.available ? <span className={VAL_TONE[f.value] || "text-slate-200"}>{f.value}</span> : <span className="text-slate-600">not available</span>}
          </div>
        ))}
      </div>

      <div className="mt-3 grid grid-cols-2 gap-3 border-t border-slate-800 pt-3" title="MOCK placeholder — per-entity statuses have no backend feed">
        <div>
          <p className="mb-1 text-[10px] uppercase tracking-wide text-slate-500">Models<span className="text-[8px] align-super">*</span></p>
          {MOCK_PULSE.models.map((m) => (
            <div key={m.name} className="flex items-center gap-1.5 text-[11px] text-slate-300"><span className={`h-1.5 w-1.5 rounded-full ${DOT[m.status]}`} />{m.name}</div>
          ))}
        </div>
        <div>
          <p className="mb-1 text-[10px] uppercase tracking-wide text-slate-500">Operators<span className="text-[8px] align-super">*</span></p>
          {MOCK_PULSE.operators.map((o) => (
            <div key={o.name} className="flex items-center gap-1.5 text-[11px] text-slate-300"><span className={`h-1.5 w-1.5 rounded-full ${DOT[o.status]}`} />{o.name}</div>
          ))}
        </div>
      </div>
      <p className="mt-1 text-[9px] text-slate-600">* placeholder (mock)</p>
    </div>
  );
}
